import Contacts from './Contacts';
import './style/index.less';

export default Contacts;
